<template>
  <div class="top-tab-box fixation">
    <div class="m-width clearfix">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import '../../html/components/topTab/topTab.scss';
export default {
    name: 'headerWrapper'
};
</script>

<style></style>
